import { BlankSlate, Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const NotEnabledPage = () => {
  return (
    <ResponsivePage.Body showHeader={false}>
      <Box alignItems="center" justifyContent="flexStart" width="full" style={{ height: '90vh' }}>
        <BlankSlate
          illustration="sign-post"
          title={i18n.t('marketplace.not_enabled.title')}
          description={i18n.t('marketplace.not_enabled.description')}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default NotEnabledPage
